import { useToast } from '@components/index'
import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { BaseParams } from 'types/utils'

export function useDeleteFlat() {
  const toast = useToast()
  const queryClient = useQueryClient()
  const navigate = useNavigate()
  const { t } = useTranslation('backend')

  async function deleteFlat({ id }: BaseParams<{}>) {
    const response = await apiClient.delete(SNA_PREFIX + `flats/${id}`)
    return response.data
  }

  return useMutation({
    mutationFn: deleteFlat,
    onSuccess: () => {
      toast.success({ message: t('backend.flat_deleted_successfully') })
      queryClient.invalidateQueries({ queryKey: ['equipment'] })
      navigate('/admin/flats')
    },
    onError: (error: any) => {
      // The ApiError.message already contains the backend error key (e.g., "backend.flat_has_contract")
      const errorMessage = error?.message || 'backend.unknown_error'
      const translatedMessage = t(errorMessage, {
        defaultValue: t('backend.delete_error')
      })
      toast.error({ message: translatedMessage })
    }
  })
}
